"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "54.78",
    height: "24",
    viewBox: "0 0 54.78 24",
    fill: "#1d1d1b"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.15,22.49a2.38,2.38,0,0,0,2.06-1.18H4.09A2.38,2.38,0,0,0,6.15,22.49Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M40.38,22.49a2.38,2.38,0,0,0,2.06-1.18H38.32A2.38,2.38,0,0,0,40.38,22.49Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14.06,22.49a2.38,2.38,0,0,0,2.06-1.18H12A2.38,2.38,0,0,0,14.06,22.49Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M48.29,22.49a2.41,2.41,0,0,0,2.07-1.18H46.23A2.39,2.39,0,0,0,48.29,22.49Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M46.28,5.66a.5.5,0,0,1,.5-.5h4.11a.5.5,0,0,1,.5.5v5.47a.5.5,0,0,1-.5.5H46.78a.5.5,0,0,1-.5-.5Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.06,18.42a.5.5,0,0,0,.5-.5V4a.5.5,0,0,0-.5-.5H7.54A.5.5,0,0,0,7,4V17.92a.5.5,0,0,0,.5.5ZM7.74,6.66a2.5,2.5,0,0,1,2.5-2.5h.12a2.5,2.5,0,0,1,2.5,2.5v4.25a2.5,2.5,0,0,1-2.5,2.5h-.12a2.5,2.5,0,0,1-2.5-2.5Z",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M54,0H.75A.75.75,0,0,0,0,.74V20.57a.75.75,0,0,0,.75.74h1.7a3.89,3.89,0,0,0,7.39,0h.53a3.89,3.89,0,0,0,7.39,0H36.68a3.89,3.89,0,0,0,7.39,0h.53a3.89,3.89,0,0,0,7.39,0h2a.75.75,0,0,0,.75-.74V.74A.75.75,0,0,0,54,0ZM6.15,22.49a2.38,2.38,0,0,1-2.06-1.18H8.21A2.38,2.38,0,0,1,6.15,22.49Zm7.91,0A2.38,2.38,0,0,1,12,21.31h4.12A2.38,2.38,0,0,1,14.06,22.49Zm26.32,0a2.38,2.38,0,0,1-2.06-1.18h4.12A2.38,2.38,0,0,1,40.38,22.49Zm7.91,0a2.39,2.39,0,0,1-2.06-1.18h4.13A2.41,2.41,0,0,1,48.29,22.49Zm5-8.55H37.7v1.89H53.28v4H1.5v-4H6v2.09a1.5,1.5,0,0,0,1.5,1.5h5.52a1.5,1.5,0,0,0,1.5-1.5V15.8l.18,0h6V13.94h-6a.57.57,0,0,0-.18,0V4a1.5,1.5,0,0,0-1.5-1.5H7.54A1.5,1.5,0,0,0,6,4v9.91H1.5V1.49H53.28ZM7,17.92V4a.5.5,0,0,1,.5-.5h5.52a.5.5,0,0,1,.5.5V17.92a.5.5,0,0,1-.5.5H7.54A.5.5,0,0,1,7,17.92Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.74,5.16H16.3a.5.5,0,0,0-.5.5v5.47a.5.5,0,0,0,.5.5h4.44V5.16Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M37.7,11.63h7.12a.5.5,0,0,0,.5-.5V5.66a.5.5,0,0,0-.5-.5H37.7v6.47Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "46.28",
    y: "5.16",
    width: "5.12",
    height: "6.47",
    rx: "0.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.74",
    y: "4.16",
    width: "5.12",
    height: "9.24",
    rx: "2.5"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "23.74",
    y: "5.5",
    width: "10.95",
    height: "10.95"
  }));
};

exports["default"] = _default;